import request from '@/utils/request'

export function login(data) {
  return request({ url: '/api/sys/auth/login', method: 'post', data })
}

export function logout() {
  return request({ url: '/api/sys/auth/logout', method: 'post' })
}
